import { useEffect } from "react";
import FullScreenLoader from "@entrilia/shared/components/fullScreenLoader/FullScreenLoader";
import { redirectToLogout } from "./authRedirects";

const LogoutContainer = () => {
  useEffect(() => redirectToLogout(), []);

  return <FullScreenLoader title="Please wait." subtitle="We're logging you out..." />;
};

export default LogoutContainer;
